import PlayBtn from "../../assets/images/play-btn.png";

export const smartSoftGame = {
  JetX: {
      href: "/casino/aggapsmartsoftgaming-jetx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/JetX.webp",
      alt: "JetX",
      name: "JetX",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    Cappadocia: {
      href: "/casino/aggapsmartsoftgaming-cappadocia",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Cappadocia.webp",
      alt: "Cappadocia",
      name: "Cappadocia",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    JetX3: {
      href: "/casino/aggapsmartsoftgaming-jetx3",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/JetX3.webp",
      alt: "JetX3",
      name: "JetX3",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    CricketX: {
      href: "/casino/aggapsmartsoftgaming-cricketx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/CricketX.webp",
      alt: "CricketX",
      name: "CricketX",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    FootballX: {
      href: "/casino/aggapsmartsoftgaming-footballx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/FootballX.webp",
      alt: "FootballX",
      name: "FootballX",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    TowerX: {
      href: "/casino/aggapsmartsoftgaming-towerx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/TowerX.webp",
      alt: "TowerX",
      name: "TowerX",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    // SpinX: {
    //   href: "/casino/aggapsmartsoftgaming-spinx",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "ALT_GAMING_GAP",
    //   category: "others",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/smartsoft/SpinX.webp",
    //   alt: "SpinX",
    //   name: "SpinX",
    //   providerName: "SmartSoft",
    //  playImg: PlayBtn,
    // },
    PlinkoX: {
      href: "/casino/aggapsmartsoftgaming-plinkox",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/PlinkoX.webp",
      alt: "PlinkoX",
      name: "PlinkoX",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    HunterX: {
      href: "/casino/aggapsmartsoftgaming-hunter-x",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/CrazyHuntX.webp",
      alt: "Hunter X",
      name: "Hunter X",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    Jokers4Bonuses: {
      href: "/casino/aggapsmartsoftgaming-4-bonuses-bonanza",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Jokers4Bonuses.webp",
      alt: "Joker's 4 Bonuses",
      name: "Joker's 4 Bonuses",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    Samurai: {
      href: "/casino/aggapsmartsoftgaming-samurai",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Samurai.webp",
      alt: "Samurai",
      name: "Samurai",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    BurningIce: {
      href: "/casino/aggapsmartsoftgaming-burning-ice",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/BurningIce.webp",
      alt: "Burning Ice",
      name: "Burning Ice",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    BurningIce10: {
      href: "/casino/aggapsmartsoftgaming-burning-ice-10",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/BurningIce10.webp",
      alt: "Burning Ice 10",
      name: "Burning Ice 10",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    BurningIce40: {
      href: "/casino/aggapsmartsoftgaming-burning-ice-40",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/BurningIce40.webp",
      alt: "Burning Ice 40",
      name: "Burning Ice 40",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    Vampires: {
      href: "/casino/aggapsmartsoftgaming-vampires",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Vampires.webp",
      alt: "Vampires",
      name: "Vampires",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    MultiHot5: {
      href: "/casino/aggapsmartsoftgaming-multi-hot-5",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/MultiHot5.webp",
      alt: "Multi Hot 5",
      name: "Multi Hot 5",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    WildJungle: {
      href: "/casino/aggapsmartsoftgaming-wild-jungle",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/WildJungle.webp",
      alt: "Wild Jungle",
      name: "Wild Jungle",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    GeniesBonanza: {
      href: "/casino/aggapsmartsoftgaming-genies-bonanza",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/GeniesBonanza.webp",
      alt: "Genie's Bonanza",
      name: "Genie's Bonanza",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    MultiHotWays: {
      href: "/casino/aggapsmartsoftgaming-multi-hot-ways",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/MultiHotWays.webp",
      alt: "Multi Hot Ways",
      name: "Multi Hot Ways",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
    Balloon: {
      href: "/casino/aggapsmartsoftgaming-baloon",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crash",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Balloon.webp",
      alt: "Balloon",
      name: "Balloon",
      providerName: "SmartSoft",
       playImg: PlayBtn,
    },
};
